import type { StringLiteralLike } from "typescript";

export function displaySuccessNotification(
  msg: string,
  timeoutInMs: number = 5000
) {
  const { $i18n } = useNuxtApp();
  const t = $i18n.t;

  useToast().add({
    title: t(msg),
    icon: "i-heroicons-check-circle",
    timeout: timeoutInMs,
  });
}

export function displayErrorNotification(
  msg: string = "common.error",
  params?: Record<string, unknown>,
) {
  const { $i18n } = useNuxtApp();
  const t = $i18n.t;

  useToast().add({
    title: params ? t(msg, params) : t(msg),
    icon: "i-heroicons-x-circle",
    color: "red",
  });
}

export function displayWarningNotification(
  msg: string,
  timeoutInMs: number = 5000
) {
  const { $i18n } = useNuxtApp();
  const t = $i18n.t;

  useToast().add({
    title: t(msg),
    icon: "i-heroicons-exclamation-circle",
    color: "amber",
    timeout: timeoutInMs,
  });
}
